// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__18W8l","questions":"styles_questions__CaUGI","footer":"styles_footer__2ba33"};